import { createContext } from "react";
import { useState } from "react";
type AccessLevelType = { label: string; code: number };

interface UserInformation {
  id: any;
  token: string;
  fullName: string;
  mobile: string;
  access_level: AccessLevelType[];
  supplier_list: number[];
}
interface AuthenticationInterface {
  userInfo: UserInformation;
  isLogged: boolean;
  isChecked: boolean;
  setUserInfo: (shopInfo: any) => void;
  login: (info: any) => void;
  logout: () => void;
  grantPermissions: (token) => void;
}

const AuthenticationContext = createContext<AuthenticationInterface>({
  userInfo: {
    id: null,
    token: "",
    fullName: "",
    mobile: "",
    access_level: [],
    supplier_list: [],
  },
  isLogged: false,
  setUserInfo: () => {},
  login: (info) => {},
  logout: () => {},
  grantPermissions: (token) => {},
});
export default AuthenticationContext;
// account types:
export type { UserInformation, AccessLevelType };
